import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { hideVisually } from 'polished';
export const StyledVisuallyHiddenText = styled.span `
  ${hideVisually}
  -webkit-user-select: none;
  user-select: none;
`;
const VisuallyHiddenText = forwardRef(function VisuallyHiddenText(props, ref) {
    return _jsx(StyledVisuallyHiddenText, { ...props, ref: ref });
});
export default VisuallyHiddenText;
//# sourceMappingURL=VisuallyHiddenText.js.map